import { useEffect, useState } from "react";

import useCustomSelector from "../../../../redux/hooks/useCustomSelector";
import useActionCreator from "../../../../redux/hooks/useActionCreator";

import { ItemsState } from "@reducers/types/inventory/stock/items-state";

interface UseItemsList {
  itemsState: ItemsState;
  handleQuery: (key: string, value: number | string) => void;
}

export const useItemsList = (): UseItemsList => {
  const { inventoryActionsHandlers } = useActionCreator();
  const { itemsFetchActionHandler } = inventoryActionsHandlers;

  const moduleName = localStorage.getItem("module");
  const module = moduleName === "ITS" ? "ICT" : "NON_ICT";

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
    inventoryType: module,
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const itemsState = useCustomSelector(
    (store) => store.inventory.stockItemsState,
  );

  useEffect(() => {
    itemsFetchActionHandler(query);
  }, [query]);

  return {
    handleQuery,
    itemsState,
  };
};
